module.exports = __webpack_public_path__ + "static/media/18ECA49.1bbb664d.jpg";